<template>
  <router-view/>
</template> 